import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EffectsModule } from '@ngrx/effects'
import { StaffEffects } from './+state/staff.effects'
import { StaffFacade } from './+state/staff.facade'
import { StoreModule } from '@ngrx/store'
import * as fromStaff from './+state/staff.reducer'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromStaff.STAFF_FEATURE_KEY, fromStaff.staffReducer),
    EffectsModule.forFeature([StaffEffects]),
  ],
  providers: [StaffFacade],
})
export class GbDashboardStaffDataAccessModule {}
